import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getAllNovels } from "@/lib/novel";

export default function CategoryGrid() {
  const all = getAllNovels();
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
      {categories.map((category) => {
        const count = all.filter((item) => item.category === category.slug).length;
        return (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-2xl`}></i>
            </span>
            <span className="flex items-center gap-2">
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                {category.name}
              </h3>
              <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
                {count} 部
              </span>
            </span>
            <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">
              {category.desc}
            </p>
          </Link>
        );
      })}
    </div>
  );
}